/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=413c9cb0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=413c9cb0&lang=scss"
/* custom blocks */
import block0 from "./App.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__